import CreateOrderDataStore from '@/data/datastores/CreateOrderDataStore';
import apiClient from './apiClient';
import { createOrderRequest as schemaCreateOrderRequest } from './schemas';

class CreateOrderDataStoreGraphQL implements CreateOrderDataStore {
  client = apiClient();

  async register(items: string[], amount: number) {
    try {
      const response = await this.client.mutate({
        mutation: schemaCreateOrderRequest.createOrder,
        variables: { items, amount }
      });
      const { data } = response;
      return data?.createOrder;
    } catch (error) {
      throw new Error('error creating order');
    }
  }
}

export default CreateOrderDataStoreGraphQL;
